(() => {
  const headerGroup = document.getElementById('header-group');
  const tabs = document.querySelectorAll('.pp-primary-navigation');

  if (!headerGroup && !tabs.length) return;

  const root = document.documentElement;

  const syncHeaderHeight = () => {
    const height = headerGroup ? Math.ceil(headerGroup.getBoundingClientRect().height) : 0;
    const announcement = headerGroup?.querySelector('.announcement-bar, .header-announcements');
    const announcementHeight = announcement ? Math.ceil(announcement.getBoundingClientRect().height) : 0;
    const visibleHeight = Math.max(height - announcementHeight, 0);

    root.style.setProperty('--pp-header-group-height', `${height}px`);
    root.style.setProperty('--pp-announcement-height', `${announcementHeight}px`);
    root.style.setProperty('--pp-header-visible-height', `${visibleHeight}px`);
  };

  syncHeaderHeight();

  if ('ResizeObserver' in window && headerGroup) {
    new ResizeObserver(syncHeaderHeight).observe(headerGroup);
  }

  window.addEventListener('resize', syncHeaderHeight, { passive: true });
  window.addEventListener('load', syncHeaderHeight, { once: true });

  let lastScrollY = window.scrollY;
  let ticking = false;

  const revealHeaderForFocus = () => {
    document.body.classList.remove('pp-top-menu-hidden');
  };

  headerGroup?.addEventListener('focusin', revealHeaderForFocus);

  const updateHeaderVisibility = () => {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;
    const headerContainsFocus = headerGroup?.contains(document.activeElement);

    if (currentScrollY < 24) {
      document.body.classList.remove('pp-top-menu-hidden', 'pp-header-scrolled');
    } else if (headerContainsFocus) {
      document.body.classList.add('pp-header-scrolled');
      revealHeaderForFocus();
    } else if (delta > 8) {
      document.body.classList.add('pp-header-scrolled', 'pp-top-menu-hidden');
    } else if (delta < -8) {
      document.body.classList.add('pp-header-scrolled');
      document.body.classList.remove('pp-top-menu-hidden');
    } else {
      document.body.classList.toggle('pp-header-scrolled', currentScrollY >= 24);
    }

    lastScrollY = Math.max(currentScrollY, 0);
    ticking = false;
  };

  document.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateHeaderVisibility);
    },
    { passive: true }
  );
})();
